import Header from "@/types/app/header";

export default class CustomerRefusedHeader {
  public static header: Header[] = [
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "fullName",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Country",
      align: "start",
      sortable: true,
      value: "country",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Refused by",
      align: "start",
      sortable: true,
      value: "relationship",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "Refused Date",
      align: "start",
      sortable: true,
      value: "refusedDate",
      class: "item-table-header-refused",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}
